import type { CustomizationProvider, CustomizationProviderOptions } from '~/shared/customization/customization';

import type { CobrainerCustomizationProviderDependencies } from './cobrainer-customization-provider';
import { createCobrainerCustomizationProvider } from './cobrainer-customization-provider';

export { TenantNotFoundError } from './tenant-not-found-error';

export const createCustomizationProvider = (
    dependencies: Pick<CobrainerCustomizationProviderDependencies, 'validatingCobrainerApiFetcher'>,
    options: CustomizationProviderOptions,
): Promise<CustomizationProvider> =>
    createCobrainerCustomizationProvider(
        {
            storage: globalThis.localStorage,
            validatingCobrainerApiFetcher: dependencies.validatingCobrainerApiFetcher,
        },
        options,
    );
